export default class WebUI {
    constructor()
    {
        this.subscribers = [];
        this.dom_body = document.body;
        this.scroll_subscribers = [];
        this.window_width = 0;
        this.window_height = 0;

        this.scrollToHash();
        this.getWindowSize();

        this.elementsWithFullViewSize();

        window.addEventListener("scroll", this.throttle(this.scrollDepth.bind(this), 25));

        window.addEventListener("resize", this.throttle(this.elementsWithFullViewSize.bind(this), 50));
    }

    scrollToHash()
    {
        document.querySelectorAll('a[href*="#"]').forEach(anchor => {
            if(anchor.parentNode.classList.contains('active')) {
              anchor.parentNode.classList.remove('active');
            }

            anchor.addEventListener('click', function (e) {
                e.preventDefault();

                const id = this.hash;

                if(!id) {
                  return;
                }

                const target = document.querySelector(id);
                let header = document.querySelector('.js-site-header-nav');

                // header height
                let header_height = 0;
                if(header) {
                  header_height = header.clientHeight;
                  header_height = header_height + 20;
                }

                if (target) {
                    window.history.replaceState({}, "", id);
                    const y = target.getBoundingClientRect().top + window.pageYOffset - header_height;
                    window.scrollTo({top: y, behavior: 'smooth'});
                } else {
                    window.location.href = this.href;
                }

            });
        });
    }

    documentBodyFreeze(status)
    {

        if (!status) {
            this.dom_body.classList.remove('block-scroll');
            return;
        }

        if (this.dom_body.classList.contains('block-scroll')) {
            this.dom_body.classList.remove('block-scroll');
        } else {
            this.dom_body.classList.add('block-scroll');
        }
    }

    getWindowSize()
    {
        let w = window;
        let d = document;
        let e = d.documentElement;
        let g = d.getElementsByTagName('body')[0];

        this.window_width = w.innerWidth || e.clientWidth || g.clientWidth;
        this.window_height = w.innerHeight || e.clientHeight || g.clientHeight;
    }

    scrollDepth()
    {
        this.scroll_subscribers.forEach(s => {
            s(window.pageYOffset, this.window_width, this.window_height);
        })
    }

    debounce(fn, wait)
    {
        var timeout
        return function () {
            clearTimeout(timeout)
            var args = arguments
            timeout = setTimeout(function () {
                fn.apply(this, args)
            }, (wait || 1))
        }
    }

    throttle(callback, limit)
    {
        var wait = false;                  // Initially, we're not waiting
        return function () {
          // We return a throttled function
            if (!wait) {                   // If we're not waiting
                callback.call();           // Execute users function
                wait = true;               // Prevent future invocations
                setTimeout(function () {
                  // After a period of time
                    wait = false;          // And allow future invocations
                }, limit);
            }
        }
    }

    checkLCP()
    {
        new PerformanceObserver((entryList) => {
            for (const entry of entryList.getEntries()) {
                console.log("LCP candidate:", entry.startTime, entry);
            }
        }).observe({ type: "largest-contentful-paint", buffered: true });
    }

    scrollSubscribe(subscriber)
    {
        this.scroll_subscribers.push(subscriber)
    }

    elementsWithFullViewSize() {
      const elements = document.querySelectorAll('[data-break-container]');

      if(!elements) {
        return false;
      }

      this.getWindowSize();

      elements.forEach((e) => {
        let elem_width = e.clientWidth;

        let diff = (this.window_width - elem_width) / 2;
        diff = -1 * diff;


        e.style.width = '100vw';
        e.style.marginLeft = diff + 'px';

      })

    }
}
